import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../../../assets/icons/filter.svg'
import _imports_1 from '../../../../assets/icons/filter-light.svg'
import _imports_2 from '../../../../assets/aw-footer-logo.jpg'


const _hoisted_1 = { class: "report-template" }
const _hoisted_2 = { class: "section" }
const _hoisted_3 = { class: "section" }
const _hoisted_4 = {
  key: 0,
  class: "report-chart"
}
const _hoisted_5 = { class: "d-flex justify-end" }
const _hoisted_6 = { class: "benchmark-filter-menu" }
const _hoisted_7 = { class: "ml-1" }
const _hoisted_8 = { class: "footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KeyStats = _resolveComponent("KeyStats")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_BenchmarkFilterTable = _resolveComponent("BenchmarkFilterTable")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_DataQualityChart = _resolveComponent("DataQualityChart")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_card, {
      class: "report-page-card",
      outlined: "",
      flat: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (!_ctx.fetchingDataQuality)
            ? (_openBlock(), _createBlock(_component_KeyStats, {
                key: 0,
                class: "mt-4",
                type: "dataQuality",
                data: _ctx.metrics,
                tooltipVisibility: false
              }, null, 8, ["data"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "section-title" }, [
            _createElementVNode("div", { class: "section-badge" }),
            _createTextVNode(" Data Quality Benchmarking ")
          ], -1)),
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "section-content" }, " The algorithm captures almost all scores but inevitably there will be outliers, determined by IRRs which are exceptionally high or low. By setting the tolerance for outliers at a reasonable level, AgeWage establishes which outliers are a result of data inaccuracies. ", -1)),
          _createElementVNode("div", null, " AgeWage measures the percentage of IRRs that are outliers and expresses this as Suspect Data – being the percentage of IRRs that fell outside of tolerances. The metrics above indicate that " + _toDisplayString(_ctx.providerDataQuality.data_analysed) + "% of the data set (" + _toDisplayString(_ctx.formatNumber(_ctx.providerDataQuality.member_count, '0,00')) + " members) received was analysed and scored, " + _toDisplayString(_ctx.providerDataQuality.short_contrib_percent) + "% (" + _toDisplayString(_ctx.formatNumber(_ctx.providerDataQuality.short_contrib_count, '0,00')) + " members) had contribution history of less than 12 months and hence were not scored, while " + _toDisplayString(_ctx.providerDataQuality.suspect_data) + "% (" + _toDisplayString(_ctx.formatNumber(_ctx.providerDataQuality.suspect_count, '0,00')) + " members) were deemed as suspect data on account of extreme IRRs. The following graph shows the Smart Pension Data Quality against other schemes in the pension industry. ", 1)
        ]),
        (!_ctx.fetchingBechmarkingReports && !_ctx.fetchingDataQuality && _ctx.data && _ctx.data.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_v_menu, {
                    modelValue: _ctx.filterIsVisible,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filterIsVisible) = $event)),
                    "close-on-content-click": false,
                    "nudge-bottom": 15,
                    "nudge-right": 12,
                    "content-class": "benchmark-filter-menu-wrapper",
                    location: "left",
                    "max-width": "100%",
                    "min-width": "100%",
                    offset: "20",
                    transition: "slide-y-transition"
                  }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_btn, _mergeProps({
                        class: ["filter-btn elevation-6 mt-0 mx-2", { 'is-active': _ctx.filtersAreApplied }],
                        "data-testid": "FilterBtn",
                        variant: "text"
                      }, props, { size: "small" }), {
                        default: _withCtx(() => [
                          _cache[4] || (_cache[4] = _createElementVNode("span", null, "Filter", -1)),
                          _createElementVNode("div", _hoisted_7, [
                            (!_ctx.filtersAreApplied)
                              ? (_openBlock(), _createBlock(_component_v_img, {
                                  key: 0,
                                  class: "filter-icon",
                                  src: _imports_0
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.filtersAreApplied)
                              ? (_openBlock(), _createBlock(_component_v_img, {
                                  key: 1,
                                  class: "filter-icon",
                                  src: _imports_1
                                }))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 1
                      }, 16, ["class"])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_BenchmarkFilterTable, {
                        dateFilters: true,
                        filters: _ctx.filters,
                        initFilters: _ctx.appliedFilters,
                        onApply: _cache[0] || (_cache[0] = (e) => _ctx.onFiltersApplied(e))
                      }, null, 8, ["filters", "initFilters"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              (_ctx.chartData)
                ? (_openBlock(), _createBlock(_component_DataQualityChart, {
                    key: 0,
                    data: _ctx.chartData,
                    providerDataQuality: _ctx.providerDataQuality,
                    providerId: _ctx.providerId,
                    providerName: _ctx.providerName
                  }, null, 8, ["data", "providerDataQuality", "providerId", "providerName"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_8, [
          _cache[5] || (_cache[5] = _createElementVNode("div", null, null, -1)),
          _createVNode(_component_v_img, {
            class: "footer-img",
            src: _imports_2
          })
        ])
      ]),
      _: 1
    })
  ]))
}